// extracted by mini-css-extract-plugin
module.exports = {"promotional-message-checkbox":"promotional-message_promotional-message-checkbox__3cpWy"};